import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { toast } from "sonner";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, LineChart, Line } from "recharts";
import {
  DollarSign, Users, CheckCircle, XCircle, TrendingUp, Calculator, FileText,
  Eye, Plus, Filter, Download, Search, ArrowRight, ArrowDown, ArrowLeft,
  Zap, Trash2, Loader2, Calendar, Upload, AlertCircle, Settings, Check,
  RefreshCw, Car, LogOut, Lock, Mail, Send, UserCheck, ChevronLeft
} from "lucide-react";
import { API, axios, formatIcelandicNumber, calculatePenaltyInterest, getLoanTypeLabel } from "@/utils/constants";
import { generatePaymentSchedule } from "@/utils/paymentSchedule";
import { useAuth } from "@/context/AuthContext";
import { SettingsForm } from "@/pages/SettingsForm";

// Settings Page Component
export const SettingsPage = () => {
  return (
    <div className="p-8" data-testid="settings-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Stillingar</h1>
        <SettingsForm />
      </div>
    </div>
  );
};

